import React from "react";
import arrow from "../../../assets/arrow.png";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero">
      <div className="container">
        <div className="hero-grid">
          <div id="w-node-cd88ec6e-ffce-91ae-f983-c486d7c00390-4b337b4c">
            <div
              data-w-id="1b778463-1db1-7ddc-ca72-49cc0cc018f0"
              className="flex-tag"
            >
              <div className="bullet-tag"></div>
              <div className="title-tag">Welcome to Win Migration Group</div>
            </div>
            <h1
              data-w-id="24911b75-eebd-f9ec-5f58-1a01f6007112"
              className="main-display"
            >
              Your Australian Dream <br /> Starts{" "}
              <span className="add-line">Here.</span>
            </h1>
            <div className="margin-40px">
              <p
                data-w-id="8e78b560-2d25-5354-601e-b5c97f9e16e3"
                className="subhead-main"
              >
                Helping you achieve your dreams!
                <br />
                <br />
                Achieving your Australian dream doesn’t have to be complicated
                or stressful.
                <br /> At{" "}
                <strong class="bold-text-3">Win Migration Group</strong>, we are
                dedicated to making your migration journey simple, seamless, and
                stress-free.
              </p>
            </div>
            <div className="margin-50px">
              <div
                data-w-id="ab8b99df-ebdc-d32a-8b58-87f78714edb1"
                className="button-flex center"
              >
                <a
                  href="https://visa-winmigrationgroup.zohobookings.com.au/#/winmigrationgroup"
                  class="relative inline-flex items-center justify-center p-4 px-6 py-3 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 rounded-full shadow-md group"
                >
                  <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-purple-500 group-hover:translate-x-0 ease">
                    <svg
                      class="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      ></path>
                    </svg>
                  </span>
                  <span class="absolute flex items-center justify-center w-full h-full text-purple-500 transition-all duration-300 transform group-hover:translate-x-full ease">
                    Book a Consultation
                  </span>
                  <span class="relative invisible">Book a Consultation</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
